import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasResponsabilidadPuntualidadAtom, puntajeTotalResponsabilidadPuntualidadAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasResponsabilidadPuntualidad = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalResponsabilidadPuntualidadAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasResponsabilidadPuntualidadAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasResponsabilidadPuntualidad;
